export default __webpack_public_path__ + "static/exchange-graphic-tilted-c482b32801fc894b03a4db35f34ec91c.svg";